var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBGray = function SvgArrowBGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20.53 27.47-1.06 1.06L12 21.06l-7.47 7.47-1.06-1.06L12 18.94z",
    fill: "#afb4b9",
    fillRule: "evenodd"
  })));
};
export default SvgArrowBGray;